// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.selected-language {
  padding: 5px;
  margin-right: 10px;
  border-radius: 5px;
  cursor: pointer;
  background-color: rgb(233, 233, 233);
  font-weight: bold;
}

.not-selected-language {
  padding: 5px;
  margin-right: 10px;
  border-radius: 5px;
  cursor: pointer;
  background-color: rgb(245, 245, 245);
}

.fake-input {
  border: 1px solid #ccc;
  padding: 8px;
  width: 100%;
  display: inline-block;
  box-sizing: border-box;
  font-size: 16px;
  font-family: inherit;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  background-color: #f9f9f9;
}

.btn-container {
  display: flex;
  justify-content: flex-end;
  gap: 5px;
}
.btn-container button.appic-btn {
  padding: 0 12px;
}
.btn-container button:hover {
  cursor: pointer;
}

.editor-container {
  position: relative;
  padding-bottom: 40px;
  width: 100%;
  margin: 0 15px;
}
.editor-container ngx-editor-menu {
  font-size: 15px;
  position: absolute;
  bottom: 0;
  left: 5px;
  display: flex;
  text-align: end;
  z-index: 5;
}
.editor-container app-insert-emoji {
  position: absolute;
  left: 45px;
  bottom: 0;
  display: flex;
  align-items: center;
  width: 30px;
  height: 30px;
  justify-content: center;
  margin: 3px;
}
.editor-container app-insert-emoji:hover {
  background: #f1f1f1;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
